// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');
const { connect } = require('react-redux');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { recordLink } = require("utilities/tagging");

// @ components
const { OKLink } = require('commonsComponents/OKLink');
import { OKMessage, MESSAGE_TYPE_INFORMATIVE } from 'commonsComponents/OKMessage'

// @ constants
const translationContext = 'disclaimerPersonalInfo-';
const { LINK_CLICK_ACTION_EVENT } = require('constants/tagging');

class ContractDisclaimerPersonalInfo extends React.Component {

    render() {
        const { cssModifier, messageKey, messageTitleKey, linkTextKey, linkUrlKey, immParameters, customTaggingCategory, type } = this.props;
        const urlParameters = immParameters && typeof immParameters.getIn === 'function' && immParameters.getIn(['contratos', 'proteccion_datos']);
        const url = formatText(`${translationContext}${linkUrlKey}`, [urlParameters]);
        const disclaimerClasses = classNames(
            'contract-view__disclaimer-personal-info',
            { [`contract-view__disclaimer-personal-info--${cssModifier}`]: cssModifier }
        );
        const typeMessage = type || MESSAGE_TYPE_INFORMATIVE
        return (
            <div className={disclaimerClasses}>
                <OKMessage type={typeMessage}>
                    {messageTitleKey && <p className='message__title'><FormattedText value={`${translationContext}${messageTitleKey}`} /></p>}
                    <FormattedText value={`${translationContext}${messageKey}`} />
                    &nbsp;
                    <OKLink 
                        modifier={"emphasize"} 
                        to={url}
                        target="_blank" 
                        onClick={() => recordLink(customTaggingCategory ? customTaggingCategory : window.utag_last_name, LINK_CLICK_ACTION_EVENT, formatText(translationContext + linkTextKey))}
                    >
                        <FormattedText value={`${translationContext}${linkTextKey}`} />
                    </OKLink>
                </OKMessage>
            </div>
        );
    }
}

ContractDisclaimerPersonalInfo.defaultProps = {
    customTaggingCategory: null
};

ContractDisclaimerPersonalInfo.propTypes = {
    customTaggingCategory: PropTypes.string,
    cssModifier: PropTypes.string,
    linkTextKey: PropTypes.string.isRequired,
    linkUrlKey: PropTypes.string.isRequired,
    messageKey: PropTypes.string.isRequired,
    immParameters: PropTypes.object.isRequired
};

module.exports.constructor = ContractDisclaimerPersonalInfo;
module.exports.ContractDisclaimerPersonalInfo = connect(
    state => ({
        immParameters: state.globalVariables.getIn(['variables', 'parameters']) || {}
    })
)(ContractDisclaimerPersonalInfo);
